import type { PortableTextBlock } from "@portabletext/types";

const url = "/api/v1/program";

export interface Material {
  _id: string;
  file: string | null;
  link: string | null;
  title: string;
  type: "docx" | "link" | "pdf";
}

interface Speaker {
  _id: string;
  alt: string | null;
  body: PortableTextBlock[];
  imgSrc: string | null;
  name: string;
}

interface Week {
  _id: string;
  body: PortableTextBlock[];
  materials: Material[] | null;
  speaker: Speaker | null;
  surveyLink: string | null;
  title: string;
}

export interface ProgramIndexResponse {
  _id: string;
  weeks: Week[];
}

export const programIndexQuery = () => url;
